import axios from 'axios';

const baseURL = `${process.env.REACT_APP_API_URL}`;

export const invoiceAPI = {
  add: async (info) => axios.post(`${baseURL}/invoices`, info).then((res) => res.data),
  all: async () => axios.get(`${baseURL}/invoices`).then((res) => res.data),
  single: async (idToSearch) => axios.get(`${baseURL}/single-invoice/${idToSearch}`).then((res) => res.data),
  update: async (idToSearch) => {
    const { id, ...details } = idToSearch;
    return axios.put(`${baseURL}/single-invoice/${id}`, details).then((res) => res.data);
  },
  delete: async (idToSearch) => axios.delete(`${baseURL}/single-invoice/${idToSearch}`).then((res) => res.data)
};
